define('modules/editor/models/property_groups/html_content',['require','exports','module','./base','../editorstate','lib/util'],function(require, exports, module) {
  var BasePropertyGroup = require("./base"),
      EditorState = require("../editorstate"),
      util = require("lib/util");

  module.exports = BasePropertyGroup.extend({
    name: "html:content",
    editAllowed: false,
    properties: ["content"],
    //NOTE: this property group is "rendered" from the element view itself
    // See views/elements/html
  });
});
